import React from "react";
import { Link } from "react-router-dom";

function Footer(){

    return (

        <>
        <>
  {/* Footer Section Start */}
  <footer className="main-footer bg-section dark-section">
    <div className="container">
      <div className="row">
       
        <div className="col-lg-4">
          {/* Footer Links Start */}
          <div className="footer-links footer-newsletter-box">
            <h3>Subscribe To Our Newsletter</h3>
            <p>
              Funfair Where thrilling rides, vibrant festivals, and endless fun
              come alive!
            </p>
            <div className="footer-newsletter-form">
              <form id="newslettersForm" action="#" method="POST">
                <div className="form-group">
                  <input
                    type="email"
                    name="mail"
                    className="form-control"
                    id="mail"
                    placeholder="Enter Email Address *"
                    required=""
                  />
                  <button type="submit" className="newsletter-btn">
                    <i className="fa-regular fa-paper-plane" />
                  </button>
                </div>
              </form>
            </div>
          </div>
          {/* Footer Links End */}
        </div>
        <div className="col-lg-3 col-md-5">
          {/* Footer Links Start */}
          <div className="footer-links">
            <h3>Address Information</h3>
            {/* Footer Contact Item List Start */}
            <div className="footer-contact-item-list">
              {/* Footer Contact Item Start */}
              <div className="footer-contact-item">
                <div className="icon-box">
                  <img src="images/icon-location-white.svg" alt="" />
                </div>
                <div className="footer-contact-item-content">
                  <p> C/O- Rajkishore Mohapatra Infront of Forest Office</p>
                  <p>PIN : 752111 , Konark</p>
                </div>
              </div>
              {/* Footer Contact Item End */}
            </div>
            {/* Footer Contact Item List End */}
            {/* Footer Social Link Start */}
            <div className="footer-social-links">
              <ul>
                <li>
                  <Link to="https://www.facebook.com/profile.php?id=61581200975135" target="_blank">
                    <i className="fa-brands fa-facebook-f" />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.youtube.com/@KonarkPathautsav" target="_blank">
                    <i className="fa-brands fa-youtube" />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.instagram.com/konarkpathautsav/" target="_blank">
                    <i className="fa-brands fa-instagram" />
                  </Link>
                </li>
                <li>
                  <Link to="https://x.com/konarkpatha" target="_blank">
                    <i className="fa-brands fa-x" />
                  </Link>
                </li>
              </ul>
            </div>
            {/* Footer Social Link End */}
          </div>
          {/* Footer Links End */}
        </div>
        <div className="col-lg-2 col-md-3">
          {/* Footer Links Start */}
          <div className="footer-links">
            <h3>Our Pages</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/About">About Us</Link>
              </li>
              <li>
                <Link to="/image-gallery">Image Gallery</Link>
              </li>
              <li>
                <Link to="/video-gallery">Video Gallery</Link>
              </li>
              
            </ul>
          </div>
          {/* Footer Links End */}
        </div>
        <div className="col-lg-3 col-md-4">
          {/* Footer Links Start */}
          <div className="footer-links">
            <h3>Contact Information</h3>
            {/* Footer Contact Item List Start */}
            <div className="footer-contact-item-list">
              {/* Footer Contact Item Start */}
              <div className="footer-contact-item">
                <div className="icon-box">
                  <img src="images/icon-phone-white.svg" alt="" />
                </div>
                <div className="footer-contact-item-content">
                  <h3>Phone Number</h3>
                  <p>
                    <a href="tel:+9124702436">+(91) 9124702436</a>
                  </p>
                </div>
              </div>
              {/* Footer Contact Item End */}
              {/* Footer Contact Item Start */}
              <div className="footer-contact-item">
                <div className="icon-box">
                  <img src="images/icon-mail-white.svg" alt="" />
                </div>
                <div className="footer-contact-item-content">
                  <h3>Email Address</h3>
                  <p>
                    <a href="mailto:info@konarkpathautsav.com">info@konarkpathautsav.com</a>
                  </p>
                </div>
              </div>
              {/* Footer Contact Item End */}
            </div>
            {/* Footer Contact Item List End */}
          </div>
          {/* Footer Links End */}
        </div>
      </div>
    </div>
    {/* Footer Copyright Start */}
    <div className="footer-copyright">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* Footer Copyright Box Start */}
            <div className="footer-copyright-box">
              <div className="footer-copyright-text">
                <p>Copyright © 2025 All Rights Reserved.</p>
              </div>
              {/* Footer Menu Start */}
             
              {/* Footer Menu End */}
            </div>
            {/* Footer Copyright  */}
          </div>
        </div>
      </div>
    </div>
    {/* Footer Copyright End */}
  </footer>
  {/* Footer Section End */}
</>

        </>
    );
}

export default Footer;